import { BASE_ENDPOINT } from "../../../endpoint";

export const deleteChartOfAccountService = async (token: string, institutionId: string, chartOfAccountId: string) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/user/accounting/institution/${institutionId}/chartofaccount/${chartOfAccountId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
